__turbopack_context__.v({
  "addCartPlaceholder": "styles-module-scss-module__ni_68q__addCartPlaceholder",
  "body": "styles-module-scss-module__ni_68q__body",
  "brandBar": "styles-module-scss-module__ni_68q__brandBar",
  "brandPlaceholder": "styles-module-scss-module__ni_68q__brandPlaceholder",
  "ghostCard": "styles-module-scss-module__ni_68q__ghostCard",
  "iconPlaceholder": "styles-module-scss-module__ni_68q__iconPlaceholder",
  "imageContainerPlaceholder": "styles-module-scss-module__ni_68q__imageContainerPlaceholder",
  "imagePlaceholder": "styles-module-scss-module__ni_68q__imagePlaceholder",
  "priceBar": "styles-module-scss-module__ni_68q__priceBar",
  "priceColumn": "styles-module-scss-module__ni_68q__priceColumn",
  "pricePlaceholder": "styles-module-scss-module__ni_68q__pricePlaceholder",
  "shimmer": "styles-module-scss-module__ni_68q__shimmer",
  "sizePlaceholder": "styles-module-scss-module__ni_68q__sizePlaceholder",
  "stats": "styles-module-scss-module__ni_68q__stats",
  "text": "styles-module-scss-module__ni_68q__text",
  "timePlaceholder": "styles-module-scss-module__ni_68q__timePlaceholder",
  "titlePlaceholder": "styles-module-scss-module__ni_68q__titlePlaceholder",
  "vendorPlaceholder": "styles-module-scss-module__ni_68q__vendorPlaceholder",
});
